import styles from './styles.module.scss';
import LineBreak from '../LineBreak';
import useScreenSize from '../../hooks/useScreenSize';
import OficinasPlacesMobile from '../OficinasPlacesMobile';

function OficinasPlaces() {
  const { isTablet } = useScreenSize();

  if (isTablet) {
    return <OficinasPlacesMobile />;
  }

  return (
    <section className={styles.placesSection}>
      <div className={styles.oficinasPlacesContent}>
        <div className={styles.leftContent}>
          <div className={styles.title}>
            Além dos colégios oficinas também podem acontecer em:{' '}
            <strong>Condomínios, Clubes, Igrejas,</strong>
            <LineBreak />
            ou outras localidades onde se possa reunir grupos de crianças e
            adolescentes.
          </div>
          <div className={styles.contentRow}>
            <div className={styles.firstColumn}>
              <div className={styles.imgLeft} />
              <div className={styles.bottomText}>
                Também fazemos palestras para{' '}
                <strong>pais e professores.</strong>
              </div>
            </div>
            <div className={styles.secondColumn}>
              <div className={styles.imgRight} />
            </div>
          </div>
        </div>
        <div className={styles.imgTall} />
      </div>
    </section>
  );
}

export default OficinasPlaces;
